import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home/Home.vue";
// import EntryPage from "../views/home.vue";
// import Login from "../views/Login/Login.vue";

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
const routes = [
    {
        path: "/",
        name: "EntryPage",
        component: () => import("../views/home.vue"),
        redirect: '/home',
        children: [  //home二级路由的配置
            {
                path: 'home',
                name: 'home',
                component: () => import("../views/Home/Home.vue")
            },
            {
                path: "bookflight",
                name: "BookFlight",
                component: () => import("../views/BookFlight/BookFlight.vue")
            },
            {
                path: "multiCity",
                name: "multiCity",
                component: () => import("../views/BookFlight/multiCity.vue")
            }, {
                path: "checkin",
                name: "checkin",
                component: () => import("../views/PreparingFlight/OnlineCheckin.vue")
            }, {
                path: "status",
                name: "status",
                component: () => import("../views/PreparingFlight/FlightStatus.vue")
            }, {
                path: "management",
                name: "management",
                component: () => import("../views/PreparingFlight/OrderManagement.vue")
            }, {
                path: "orderinformation",
                name: "orderinformation",
                component: () => import("../views/OrderInformation/OrderInformation.vue")
            },

            {
                path: "preparingflight",
                name: "PreparingFlight",
                component: () => import("../views/PreparingFlight/PreparingFlight.vue")
            },
            {
                path: "prepareflighttext",
                name: "PrepareForFlightText",
                component: () => import("../views/PreparingFlight/PrepareForFlightText.vue")
            },
            {
                path: "specialoffer",
                name: "SpecialOffer",
                component: () => import("../views/SpecialOffer/SpecialOffer.vue")
            },
            {
                path: "Information",
                name: "Information",
                component: () => import("../views/Information/Information.vue")
            },
            {
                path: "goldenpandaclub",
                name: "GoldenPandaClub",
                component: () => import("../views/GoldenPandaClub/GoldenPandaClub.vue")
            },
            {
                path: "news",
                name: "News",
                redirect: '',
                component: () => import("../views/News/News.vue"),
                children: [
                    // {
                    //   path: 'newsdetails',
                    //   name: 'news',
                    //   component: () => import("../views/News/NewsDetails/NewsDetails.vue"),
                    // }
                ]
            },
            {
                path: "sitemap",
                name: "SiteMap",
                component: () => import("../views/SiteMap/SiteMap.vue"),
            }, {
                path: "interlayer",
                name: "interlayer",
                component: () => import("../views/interlayer/interlayer.vue"),
            },
            {
                path: "/news/newsdetails",
                name: "NewsDetails",
                component: () => import("../views/News/NewsDetails/NewsDetails.vue"),
            },
            {
                path: "CarryOnBaggage",
                name: "CarryOnBaggage",
                component: () => import("../views/CarryOnBaggage/index.vue"),
            },
            {
                path: "NoticeToPassengers",
                name: "NoticeToPassengers",
                component: () => import("../views/NoticeToPassengers/index.vue"),
            },
        ],
    },
    {
        path: "/login",
        name: "Login",
        // component: Login
        component: () => import("../views/Login/Login.vue")
    },
];


const router = new VueRouter({
    routes
});
// 路由管道查询 token检测
// router.beforeEach((to, from, next) => {
//   // debugger
//   console.log(to, from, next)
//   // let token = 'aa'
//   // if (to.matched.some(r => r.meta.requireAuth)) {
//   //     if (token) {
//   //         next();
//   //     }
//   //     else {
//   //         next({
//   //             path: '/login',
//   //             query: {redirect: to.fullPath}
//   //         })
//   //     }
//   // }
//   // else {
//   //     next();
//   // }
// })
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
});
export default router;
